import { render, staticRenderFns } from "./DatosLevantamiento.vue?vue&type=template&id=227b2b2e&"
import script from "./DatosLevantamiento.vue?vue&type=script&lang=js&"
export * from "./DatosLevantamiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports